/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wsc_remove_blank = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove blank lines`)
};

const es_wsc_remove_blank = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar líneas en blanco`)
};

const de_wsc_remove_blank = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leerzeilen entfernen`)
};

const nl_wsc_remove_blank = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lege regels verwijderen`)
};

const fr_wsc_remove_blank = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer les lignes vides`)
};

const it_wsc_remove_blank = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi righe vuote`)
};

const pt_br2_wsc_remove_blank = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover linhas em branco`)
};

const pt_wsc_remove_blank = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover linhas em branco`)
};

const ja_wsc_remove_blank = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空白行を削除`)
};

const zh_wsc_remove_blank = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除空行`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wsc_remove_blank = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wsc_remove_blank(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wsc_remove_blank", locale)
	if (locale === "en") return en_wsc_remove_blank(inputs)
	if (locale === "es") return es_wsc_remove_blank(inputs)
	if (locale === "de") return de_wsc_remove_blank(inputs)
	if (locale === "nl") return nl_wsc_remove_blank(inputs)
	if (locale === "fr") return fr_wsc_remove_blank(inputs)
	if (locale === "it") return it_wsc_remove_blank(inputs)
	if (locale === "pt-BR") return pt_br2_wsc_remove_blank(inputs)
	if (locale === "pt") return pt_wsc_remove_blank(inputs)
	if (locale === "ja") return ja_wsc_remove_blank(inputs)
	return zh_wsc_remove_blank(inputs)
};